import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'

const PAGE_ROLE_LENGTH = 7
const MAX_ATTEMPTS = 5

export const generateUniquePageRole = async ({
  editorSdkProxy,
}: {
  editorSdkProxy: EditorSDK
}): Promise<string> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()

  const existingPageRoles = routers.flatMap(router =>
    router.pages.flatMap(page => page.pageRoles),
  )

  let attempts = 0

  do {
    const pageRole = Math.random()
      .toString(36)
      .substring(2, 2 + PAGE_ROLE_LENGTH)

    if (
      pageRole.length === PAGE_ROLE_LENGTH &&
      !existingPageRoles.includes(pageRole)
    ) {
      return pageRole
    }

    attempts++
  } while (attempts < MAX_ATTEMPTS)

  throw new Error('Failed to generate unique page role after multiple attempts')
}
